export const SET_SELECTED_DATA = 'fileexplorer/SET_SELECTED_DATA';

export const SET_VIEW_MODE = 'fileexplorer/SET_VIEW_MODE';
